module.exports = "/_next/static/images/business-planning-service-3-ea92e0e707f22c5d4beb29bb11ce7b23.webp";